import React from 'react'
import PropTypes from 'prop-types'
import STYLE_CONSTANTS from '~/style/constants'

const RegistrationCard = ({ color }) => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z" fill={color} />
      <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="22" height="22">
        <path d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z" fill="white" />
      </mask>
      <g mask="url(#mask0)">
        <path fillRule="evenodd" clipRule="evenodd" d="M4.5 6.5C3.94772 6.5 3.5 6.94772 3.5 7.5V14.5C3.5 15.0523 3.94772 15.5 4.5 15.5H17.5C18.0523 15.5 18.5 15.0523 18.5 14.5V7.5C18.5 6.94772 18.0523 6.5 17.5 6.5H4.5ZM16.5 8.5H5.5V9.5H16.5V8.5ZM5.5 10.5H16.5V11.5H5.5V10.5ZM16.5 12.5H5.5V13.5H16.5V12.5Z" fill="white" />
      </g>
    </svg>
  )
}

RegistrationCard.defaultProps = {
  color: STYLE_CONSTANTS.colors.text.buttonGray
}

RegistrationCard.propTypes = {
  color: PropTypes.string
}

export default RegistrationCard